import { render, staticRenderFns } from "./AdminTableDeleteButton.vue?vue&type=template&id=74a16ceb&scoped=true&"
import script from "./AdminTableDeleteButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a16ceb",
  null
  
)

export default component.exports